import { SVGFilterStatus } from 'components/maps';

const BoldFilter: React.FunctionComponent = () => {
  return (
    <filter id={`${SVGFilterStatus.BOLD}`}>
      <feColorMatrix
        values='0 0 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 1 0'
      />
      <feMorphology operator='dilate' radius={30} result='outlineMorph' />
      <feMerge>
        <feMergeNode in='outlineMorph' />
        <feMergeNode in='SourceGraphic' />
      </feMerge>
    </filter>
  );
};

export default BoldFilter;
